import React, { useContext } from 'react'
import { Flex } from 'pcln-design-system'
import styled from 'styled-components'
import { HighlightedFlex } from '@pcln/brand'
import PriceBreakers from '@/components/Promos/Pricebreakers'
import VIP from '@/components/Promos/VIP'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import IncredibleTile from '@/components/Promos/IncredibleTile'
import { useFeature } from '@pcln/feature-components'
import LayoutComponentWrapper from './LayoutComponentWrapper'

const HighlightedFlexStyle = styled(HighlightedFlex)`
  gap: 16px;
`

export default function PromoFeatureBox() {
  const {
    isMobile = false,
    signInStatus: { signedIn = false }
  } = useContext(BootstrapDataContext)

  const highlightColor = useFeature('siteExperience.highlightColor')

  return (
    <LayoutComponentWrapper>
      <Flex mx="auto" justifyContent="center">
        <HighlightedFlexStyle
          shadowOffsetX={24}
          shadowOffsetY={24}
          maxWidth={1216}
          flexWrap={['wrap', null, 'unset']}
          shadowColor={highlightColor}
        >
          {isMobile ? (
            <>
              <IncredibleTile
                useLayout={false}
                contentFulFieldID="incredibleTile"
              />
              {signedIn ? <VIP /> : <PriceBreakers />}
            </>
          ) : (
            <>
              {signedIn ? <VIP /> : <PriceBreakers />}
              <IncredibleTile
                useLayout={false}
                contentFulFieldID="incredibleTile"
              />
            </>
          )}
        </HighlightedFlexStyle>
      </Flex>
    </LayoutComponentWrapper>
  )
}
